import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const SettingsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        id="SettingsIcon"
        data-testid="SettingsIcon"
        className="bloxicon"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="22"
      >
        <path
          fill="currentColor"
          d="M22.156 3.663H9.638A4.992 4.992 0 0 0 4.993.489a4.992 4.992 0 1 0 0 9.986A4.992 4.992 0 0 0 9.638 7.3h12.518a1.815 1.815 0 1 0 0-3.633v-.005ZM4.993 7.7a2.218 2.218 0 1 1-.001-4.437 2.218 2.218 0 0 1 0 4.437ZM19.007 11.276a4.988 4.988 0 0 0-4.645 3.174H1.836a1.816 1.816 0 1 0-.003 3.633h12.526a4.988 4.988 0 0 0 4.646 3.173 4.992 4.992 0 1 0 0-9.985l.002.005Zm0 7.209a2.218 2.218 0 1 1 0-4.437 2.218 2.218 0 0 1 0 4.437Z"
        />
      </svg>
    </SvgIcon>
  );
};

export default SettingsIcon;
